import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTrashAlt, faSearch, faTimes, faExternalLinkAlt } from "@fortawesome/free-solid-svg-icons";
import { service } from "./service";
import "./help.css";

const AccordionItem = ({ title, content, isOpen, onClick, id, vanity_url, onDelete, onEdit, isSuperAdmin, index }) => {
  return (
    <div
      className={`help-accordion-item ${isOpen ? "active" : ""}`}
    >
      <div className="help-accordion-header" onClick={onClick}>
        <div className="help-accordion-title">
          <span>{title}</span>
        </div>
        <div className="help-accordion-actions">
          {isSuperAdmin && (
            <>
              <FontAwesomeIcon
                icon={faEdit}
                className="mr-2 edit-icon"
                onClick={(e) => {
                  e.stopPropagation();
                  onEdit(vanity_url);
                }}
              />
              <FontAwesomeIcon
                icon={faTrashAlt}
                className="mr-3 delete-icon"
                onClick={(e) => {
                  e.stopPropagation();
                  onDelete(id);
                }}
              />
            </>
          )}
          <svg
            className="accordion-icon"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M4 6L8 10L12 6"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
      </div>

      <div className={`help-accordion-content ${isOpen ? "open" : ""}`}>
        <div className="content-wrapper">{content}</div>
        <div className="read-more-link">
          <Link
            to={{ pathname: `/help/read_more/${vanity_url}` }}
            target="_blank"
            className="help-readmore-btn"
          >
            <span>Read more </span>
            <FontAwesomeIcon icon={faExternalLinkAlt} className="ml-1" />
          </Link>
        </div>
      </div>
    </div>
  );
};

const HelpAccordion = ({ items, searchTerm, setAccordionItems, setIsShowForm, setFormData, setLoading, isSuperAdmin }) => {
  const [openIndex, setOpenIndex] = useState(null);
  const [searchValue, setSearchValue] = useState(searchTerm);

  useEffect(() => setSearchValue(searchTerm) , [searchTerm]);

  const handleAccordionClick = (index) => setOpenIndex(openIndex === index ? null : index);
  const filteredItems = items.filter((item) => item.title.toLowerCase().includes(searchValue.toLowerCase()));
  const handleSearchChange = (e) => setSearchValue(e.target.value);
  const clearSearch = () => setSearchValue("");

  const handleEdit = async (vanity_url) => {
    setLoading(true);
    setIsShowForm(true);
    if (vanity_url) {
      const { data } = await service.getQuestion(vanity_url);
      setFormData({
        question: data[0].question,
        htmlDescription: data[0].answer_html,
        shortAnswer: data[0].short_answer,
        isFromEdit: true,
        qs_id: data[0].id,
      });
    }
    setLoading(false);
  };

  const handleDelete = (id) => {
    if (window.confirm("Do you want to delete this FAQ?")) {
      service.deleteQuestion(id)
        .then(response => {
          alert(response.success ? "Deleted FAQ" : "Failed to delete FAQ");
          setAccordionItems(items.filter(faq => faq.id !== id));
        })
        .catch(error => {
          console.error("Error deleting FAQ:", error);
          alert("An error occurred while deleting the FAQ");
        });
    }
  };
  return (
    <>
      <div className="help-search-container">
        <div className="help-search-input-wrapper">
          <FontAwesomeIcon icon={faSearch} className="search-icon" />
          <input
            type="text"
            placeholder="Search for help topics..."
            value={searchValue}
            onChange={handleSearchChange}
            className="help-search-input"
          />
          {searchValue && (
            <FontAwesomeIcon
              icon={faTimes}
              className="clear-search-icon"
              onClick={clearSearch}
            />
          )}
        </div>
      </div>

      <div className="help-accordion-container">
        {filteredItems.length > 0 ? (
          filteredItems.map((item, index) => (
            <AccordionItem
              key={index}
              title={item.title}
              content={item.content}
              isOpen={index === openIndex}
              onClick={() => handleAccordionClick(index)}
              id={item.id}
              vanity_url={item.vanity_url}
              onEdit={handleEdit}
              onDelete={handleDelete}
              isSuperAdmin={isSuperAdmin}
              index={index}
            />
          ))
        ) : (          
          <div className="no-results">
            <div className="no-results-icon">🔍</div>
            <p>No results found. Try a different search term.</p>
          </div>
        )}
      </div>
    </>
  );
};

export default HelpAccordion;
